import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '@/layout'

Vue.use(Router)
export const constantRoutes = [
  // {
  //     path: '/404',
  //     component: () => import('@/views/404'),
  //     hidden: true
  // },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: '',
      name: '首页',
      component: () => import('@/views/home/index'),
      meta: { title: '控制台', activeMenu: '/' }
    }]
  },
  {
    path: '/about',
    component: Layout,
    children: [{
      path: '',
      name: '关于',
      component: () => import('@/views/about/index'),
      meta: { title: '控制台', activeMenu: '/about' }
    }]
  },
  {
    path: '/article',
    component: Layout,
    children: [
      {
        path: '',
        name: '文章',
        component: () => import('@/views/article/index'),
        meta: { title: '文章列表', activeMenu: '/article' }
      },
      {
        path: 'details',
        name: '文章详情',
        component: () => import('@/views/article/detail'),
        meta: { title: '文章详情', sidebarSolid: true, activeMenu: '/article' }
      }
    ]
  }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes,
  mode: 'history'
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

// push
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

// replace
const VueRouterReplace = Router.prototype.replace
Router.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch(err => err)
}

export default router
